import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import job from '../../images/job.jpg';
import mbaba from '../../images/mbaba-logos.jpeg';
import proxmed from '../../images/proxmed.png';
import './Experience.css';
import Header from '../Shared/Header/Header';

const Experience = ({ textEnter, textLeave }) => {
  return (
    <div>
      <Header></Header>
      <Container className="my-5">
        <Row className="justify-content-md-center">
          <Col lg="8">
            <h1 className="text-center my-5">Work Experience</h1>
          </Col>
          <hr />
        </Row>
        <Row className="mt-5">
          <Col md={6} className="mb-5">
            <div>
              <a
                href="https://drive.google.com/file/d/1h5sAxEyjRMETz68wpNJ-WXxlWozvCDS7/view"
                onMouseEnter={textEnter}
                onMouseLeave={textLeave}>
                <img
                  style={{ height: '350px' }}
                  className="img-fluid experience-img"
                  src={proxmed}
                  alt="Proxmed Pty Ltd"
                />
              </a>
              <h2 className="py-3">Frontend Developer</h2>
              <h5>
                Jun 2024 – Sep 2024
                <br />
                <a
                  href="https://www.proxmed.com.au"
                  onMouseEnter={textEnter}
                  onMouseLeave={textLeave}>
                  Proxmed Pty Ltd
                </a>
                , 34 Kelland Ave, Hillside VIC 3037, Australia
              </h5>
              <p
                onMouseEnter={textEnter}
                onMouseLeave={textLeave}
                style={{ textAlign: 'justify' }}
                className="px-3">
                <span className="p-experience3">
                  {' '}
                  Developed, tested, and maintained software applications.
                  Collaborated with the development team to design and implement
                  new features. Troubleshooting and debugging issues in existing
                  software. Participated in code reviews and contributed to best
                  practices in software development.
                </span>{' '}
              </p>
            </div>
          </Col>
          <Col md={6} className="mb-5">
            <div>
              <a
                href="https://mbaba-bd.firebaseapp.com/"
                onMouseEnter={textEnter}
                onMouseLeave={textLeave}>
                <img
                  style={{ height: '350px' }}
                  className="img-fluid experience-img"
                  src={mbaba}
                  alt="Mbaba Online Store"
                />
              </a>
              <h2 className="py-3">Founder & CEO, Mbaba Online Store</h2>
              <h5>
                Dec 2023 - Apr 2024
                <br />
                <a
                  href="https://mbaba-bd.firebaseapp.com/"
                  onMouseEnter={textEnter}
                  onMouseLeave={textLeave}>
                  Mbaba-bd
                </a>
                , Nikunja-2, 1229 Dhaka, Bangladesh.
              </h5>
              <p
                onMouseEnter={textEnter}
                onMouseLeave={textLeave}
                style={{ textAlign: 'justify' }}
                className="px-3">
                <span className="p-experience3">
                  {' '}
                  Founded and managed an online eCommerce venture specializing
                  in electronics products. Developed and launched the Mbaba
                  website, overseeing all business operations.
                </span>{' '}
                <br />
                <span className="p-experience3">
                  {' '}
                  Implemented marketing strategies, maintained supplier
                  relationships, and ensured exceptional customer service in the
                  electronics retail sector.
                </span>
              </p>
            </div>
          </Col>
          <Col md={6} className="mb-5">
            <div>
              <a
                href="https://drive.google.com/file/d/1ou4l1g9hVM11OTsecfXqDIhdAGurQnps/view"
                onMouseEnter={textEnter}
                onMouseLeave={textLeave}>
                <img
                  style={{ height: '350px' }}
                  className="img-fluid experience-img"
                  src={job}
                  alt="Progeny Technologies Limited"
                />
              </a>
              <h2 className="py-3">Junior Software Engineer</h2>
              <h5>
                Jun 2022 - Oct 2023
                <br />
                <a
                  href="https://progenytech.com/"
                  onMouseEnter={textEnter}
                  onMouseLeave={textLeave}>
                  Progeny Technologies Limited
                </a>
                , Baridhara DOHS, 1206 Dhaka, Bangladesh.
              </h5>
              <p
                onMouseEnter={textEnter}
                onMouseLeave={textLeave}
                style={{ textAlign: 'justify' }}
                className="px-3 p-experience3">
                Gained experience in developing ERP software also PostgreSQL,
                Crystal Reports. Learned to work in a team environment and apply
                problem-solving skills to real-world projects.
              </p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div>
              <a
                href="https://basic-programmer.web.app/"
                onMouseEnter={textEnter}
                onMouseLeave={textLeave}>
                <img
                  style={{ height: '350px', borderRadius: '50%' }}
                  className="img-fluid experience-img"
                  src="https://i.ibb.co/gyD1qwc/logo.png"
                  alt="Basic Programmer"
                />
              </a>
            </div>
            <h2 className="py-3">
              Content Creator:{' '}
              <a
                href="https://www.youtube.com/c/BasicProgrammer"
                onMouseEnter={textEnter}
                onMouseLeave={textLeave}>
                YouTube
              </a>
            </h2>
            <h5>
              <span>
                <a
                  href="https://basic-programmer.web.app/"
                  onMouseEnter={textEnter}
                  onMouseLeave={textLeave}>
                  Basic Programmer
                </a>
              </span>
              , Jul 2021 - Present
            </h5>
            <p
              onMouseEnter={textEnter}
              onMouseLeave={textLeave}
              className="py-3 p-experience">
              <span className="p-experience2">Basic Programmer</span> provide{' '}
              <span className="p-experience2"> web application service</span> to
              customer and My videos teach viewers{' '}
              <span className="p-experience2">JavaScript development.</span>
            </p>
            <p
              onMouseEnter={textEnter}
              onMouseLeave={textLeave}
              style={{ textAlign: 'justify' }}
              className="px-3">
              I started Basic Programmer, a community of students who are
              learning to code by building real-world projects. My goal is
              simple: Teach the world to build stuff with code. <br /> <br />
              <span className="p-experience">
                Why? Because
                <span className="p-experience2"> Code + Dreams</span> = Reality.
              </span>{' '}
              <br /> <br />
              <span className="p-experience3">
                Basic Programmer provide various types of web application
                services such as{' '}
                <span className="p-experience2">
                  portfolio websites, personal websites, education websites,
                  corporate websites, e-commerce websites, we create all these
                  websites and{' '}
                </span>
                we create different types of websites according to the
                customer's requirements.
              </span>
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Experience;
